/**
 * Product Generic Grid - Master Product Grid
 *
 * @template <product-generic-grid-al-v1>
 */
import {
    Component,
    OnInit,
    Injectable,
    AfterViewInit,
    NgZone,
    ElementRef,
    OnDestroy,
    Input
} from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { takeWhile } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { Subscription } from "rxjs";

import { CommonService, UserInfoService, CartService, AemService, ProductFilterService, ShopCouponRefresh } from 'abs-ngx-library/src/lib/core';
import { EnviormentConfig } from 'abs-ngx-library/src/lib/core';

// Services.
import { ProductGenericGridALV1Service } from './product-generic-grid-al-v1.service';
import { ProductModel, SortModel, IConfigObj, DatasScrollService, LoaderService } from 'abs-ngx-library/src/lib/core';
import { SortALV1Service } from './sort-al-v1.service';

// jQuery
declare let $: any;

@Component({
    selector: 'product-generic-grid-al-v1',
    templateUrl: './product-generic-grid-al-v1.component.html',
    //providers: [SortALV1Service, ProductGridService, DatasScrollService, LoaderService]
    providers: [SortALV1Service, ProductGenericGridALV1Service, DatasScrollService, LoaderService]
})

@Injectable()
export class ProductGenericGridALV1Component implements OnInit, AfterViewInit, OnDestroy {

    @Input() dataValue;
    @Input() staticProducts;
    @Input() qualifiedProducts;
    @Input() configObj: IConfigObj;
    @Input() objGridData: any;
    @Input() calledBy: string;
    // Map that tracks component data for grid. 
    // Key is the row that the component is on. 0 is on top of grid, 1 is after row 1, etc. 
    @Input() gridComponents: Map<number, any> = new Map();
    // Flag controlled by consuming component. Required as some views of BIA page don't show zone components, like
    // the viewAll pages. 
    @Input() showGridZoneComponents: boolean = true;
    @Input() isDynamicGridFlow: boolean = false;
    @Input() set offersFromDynamicGrid(offers: {}) {
            this.dataOffers = offers;
    }
    @Input() dynamicGridHasFacets: boolean = false;
    public config = EnviormentConfig;
    private pTime: any = new Date();
    private pageByScroll: any;
    private notAvailableDisp: string[] = ['historylastorder', 'historylist', 'purchase'];
    // Infinite scroll variables
    private infiniteScrollPage = 1;
    private infiniteScrollItems: number;
    private $infiniteScroll: Subscription;
    private _isServerLoadMoreTriggered: boolean = false;
    private _serverNewItemToFocus: number;
    private _componentElement: any;

    public input: any;
    public products: ProductModel[] = [];
    public initialProducts: ProductModel[] = [];
    public productsSecondary: ProductModel[] = [];
    public brand: string[];

    public sortRules: SortModel[];
    public activeSortRule: SortModel;

    public ack: boolean = true;
    public hasSort: boolean;
    public showGrouping: string = 'mask';
    public filterAisleParam = '';
    public filterBrandParam = '';
    public isFilter: boolean = false;
    public noResults: string = '';
    public displayNoResults: boolean = false;
    public aisleHTML: any = '';
    public groupByField = window['AB']['headerType'] || 'departmentName';
    public currentGroupBy = '';
    public groupByHeadingField = '';
    public isGroupInit = false;
    public isAisleSort = false;
    public allowNotAvailable: boolean = false;
    public areAllProductsUnavailable: boolean = false;
    public unAttendDeliveryFlag: boolean = false;
    public afbEvent: string = '';
    public showBackToTopButton: boolean = false;
    public totalProducts: number = 0;
    public searchNoResults = false;
    public showGrid: boolean;
    public productColumnClass = 'col-12 col-sm-6 col-lg-4';
    public productColumnClassV2 = 'col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3';
    public component: any = {};
    public productGridPage;
    public dataOffers = {};
    public biaSort: boolean = false;
    public showAddAllItemsBtn: boolean = false;
    private arProductsArray = [];
    public enableDSTV2Theme: boolean = false;
    // README: Flag used for displaying the load-more elements for the client side product functionality.
    public hasServerSideLoadMore: boolean = false;
    public isServerGridLoading: boolean = false;
    public isArEnable: boolean = false;
    public isThemeBuilderEnabled: boolean;
    public snsFulfillmentType: string = '';
    public isCalledByRightDrawerOrOneTimeAddFlow = false;


    public isOneTimeAddFlow: boolean = false;
    public searchKeyword: string = '';

    private subscription: Subscription = new Subscription();
    public currentEnv: any;

    public productsPerRowInPCRedesign : number = 0 ;

    /** 
     * Map of array index (0th based) -> corresponding row (1 based indexing). 
     * Denotes at which array index is the end of which row. 
     */
    public fullWidthIndices: Map<number, number> = new Map();
    public wrapperName: string;
    public wrapperAttribute: string;
    public nextPageToken: string = '';

    @Input() hasCrossSell: boolean = false;

    @Input() set replacementProducts(products: ProductModel[]) {
        // Skip on first initialization of component. 
        if (this.objGridData?.usesDynamicGridWrapper !== true) return;

        // Products passed in will be null on initialization of component.
        if (products === null || products === undefined) return;

        if (products.length == 0) {
            this._processNoData();
            return;
        }

        this.products = products;
        this.handleProductsPerRowCalculations();
    }

    @Input() set additionalProducts(products: ProductModel[]) {
        if (this.objGridData?.usesDynamicGridWrapper !== true) return;
        if (products === null || products === undefined) return;

        if (products.length == 0) {
            this._processNoData();
            return;
        }

        // Chunk products and add to existing. 
        // Then focus onto the new products. 
        this.products = this.products.concat(products);
        this.handleProductsPerRowCalculations();
    }

    public constructor(
        private _productGridService: ProductGenericGridALV1Service,
        private _http: HttpClient, zone: NgZone,
        public elementRef: ElementRef,
        private _commonService: CommonService,
        private _userInfoService: UserInfoService,
        private _aemService: AemService,
        private _sortService: SortALV1Service,
        private _cartService: CartService,
        private _dataScrollService: DatasScrollService,
        private _productFilterService: ProductFilterService,
        private _loaderService: LoaderService
    ) {
        this.wrapperName = 'targeted-wrapper';
        this.wrapperAttribute = 'data-targeted-component';
        if(window?.['AB']?.['userInfo']&&!this._userInfoService.getUserSession()){
            this._userInfoService.initUserSession();
        }
        this._componentElement = this.elementRef.nativeElement;
        //Check if theme builder is enabled
        //this.isThemeBuilderEnabled = window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].isThemeBuilderEnabled ? true : false;
        this.isThemeBuilderEnabled = false;
        this.calcTime('START');
        this.showGrid = true;
        // Save component as global to extend its accessibility.
        window['productGenericGridCompRef'] = { zone: zone, component: this };

        this.enableDSTV2Theme = this._commonService.hasPageV2Theme();
    }

    public ngOnInit(): void {
        this.isCalledByRightDrawerOrOneTimeAddFlow = this.calledBy === 'c-products-by-upc-drawer' || this.calledBy === 's-bogo';
        const jsonConfigObj = this._componentElement.getAttribute('data-configObj');
        if (jsonConfigObj && this.configObj === undefined) {
            this.configObj = JSON.parse(jsonConfigObj);
            if (this.configObj?.programType === '1P_SNS' || this.configObj?.appName === '1P_OA') {
                this.setOneTimeAddFlowData();
            }
        }
        this.configObj = { ...this.configObj ?? {}, programType: this.configObj?.programType ?? 'abs' };
        localStorage.setItem('productGenericGridData', JSON.stringify(this.objGridData));
        this.component = {
            pagination: {
                load_type: this.objGridData?.load_type,
                load_items: this._getLoadMoreItems(),
                infinite_type: this.objGridData?.infinite_type,
                paginate_at: this.objGridData?.apiType === 'buy-it-again' ? 'server' : 'client',
                page: 1,
            }
        };

        // get products that are passed in from wrapper component
        if (this.qualifiedProducts) {
            this.qualifiedProducts = JSON.parse(this.qualifiedProducts);
            if (this.isOneTimeAddFlow && this.qualifiedProducts?.products?.length) {
                this.qualifiedProducts.products = this.configObj.programType === '1P_SNS' ? this.filterSnsNextOrderBpns(this.qualifiedProducts.products) : this.qualifiedProducts.products;
                this.nextPageToken = this.qualifiedProducts?.nextPageToken ?? '';
            }
        } else {
            this.qualifiedProducts = null;
        }

        if (this.isDynamicGridFlow !== true) {
            const dataOffers = this._componentElement.getAttribute('data-offers');
            if (dataOffers) {
                const offersData = JSON.parse(dataOffers) || {};
                this.dataOffers = offersData?.offers;
            }
        }
       
        this.hasSort = this._sortService.hasSort();
        this.sortRules = this._sortService.getSorts();
        this.sortRules = this.sortRules?.filter(rule => rule.label !== 'Search Ranking');

        this.products = [];
        this.calcTime('INIT');

        this.noResults = this._productGridService.getNoResultsMsg(this.productGridPage);
        this.allowNotAvailable = (this.notAvailableDisp.indexOf(this.productGridPage) !== -1) ? true : false;
        this.configObj?.appName === "cart" ?  this.allowNotAvailable = true : this.allowNotAvailable;
        this.productColumnClass = this.objGridData?.apiType === 'c-products-by-upc' || this.productGridPage === 'offer'
            ? 'col-12 col-sm-6 col-md-4 col-lg-3'
            : this.productColumnClass;

        if ((this.objGridData?.doGenericFlow === true && this.objGridData?.usesDynamicGridWrapper === false) || this.objGridData?.usesDynamicGridWrapper === true) {
            this.productColumnClassV2 = this.objGridData.apiType === 'c-products-by-upc' || this.productGridPage === 'offer' ||
                this.objGridData.apiType === 'c-products-by-upc-drawer' || this.objGridData.apiType === 's-bogo'
                ? 'col-6 col-sm-6 col-md-3 col-lg-2 col-xl-2'
                : this.productColumnClassV2; 
        }
        this.calcTime('INIT');

        this.calcTime('REQUESTED DATA');

        this._productGridService.objGridData = this.objGridData;
        localStorage.setItem('productGenericGridData', JSON.stringify(this.objGridData));


        if (
            this.productGridPage === 'erumslastorder'
            || this.productGridPage === 'historylist'
            || this.productGridPage === 'purchase'
        ) {
            this._commonService.userInfoRefresh.subscribe(data => {
                if (data === 'initFunc') {
                    this._getResults();
                }
            });
        } else {
            this._getResults();

            if (this.objGridData?.apiType === 'c-products-by-upc') {
                this._commonService.shopCouponRefreshSource.subscribe((couponRefresh: ShopCouponRefresh) => {
                    if (couponRefresh && typeof couponRefresh === 'object' && 'id' in couponRefresh && 'deleted' in couponRefresh && 'status' in couponRefresh) {
                        this._init();
                    }
                });
            }
        }

        // check if any qualified products are already in cart - show correct UI state if so
        const _currentCart = this._cartService._get();

        if (this._commonService.isEmpty(_currentCart)) {
            // load remote cart object - will handle refresh of products that are present in cart already
            this._cartService._loadERUMSRemoteCart();
        } else {
            this._commonService._cartObjSource.next(_currentCart);
        }

    }

    public setOneTimeAddFlowData() {
        this.qualifiedProducts = this._componentElement.getAttribute('data-products');
        const currentOrderData = this._componentElement.getAttribute('data-current-order-data');
        this._commonService.orderAmendsCurrentOrderData = currentOrderData ? JSON.parse(currentOrderData) : {};
        this.isOneTimeAddFlow = true;
        this.isCalledByRightDrawerOrOneTimeAddFlow = true;
        this.searchKeyword = this.configObj['data-search-key'];
        this.snsFulfillmentType = this.configObj['data-fulfillment-channel'];
        const attributes = this._componentElement.attributes;
        this.objGridData = {
            drivenType: "catalog",
            apiUrl: '',
            apiType: '',
            sorts: false,
            defaultSort: undefined,
            value: {},
            products: [],
            widgetId: false,
            load_type: attributes['data-load-type']?.value ?? 'loadmore',
            infinite_type: attributes['data-infinite-scroll-type']?.value ?? 'client',
            badgePreference: attributes['data-badge-preferrence']?.value || '',
            badgeList: attributes['data-badge-list']?.value || ''
        };
    }

    private _getResults() {
        // We should wait until AR flag (true/false) is resolved/loaded 
        // then trigger xAPI to get the products
        // if(window['AB']['arFlagLoaded']){
        if (this._aemService.isArFlagLoaded()) {
            this.isArEnable = this._aemService.getArFlag()?.display;
            console.warn('== PRODUCT GENERIC GRID DECIDED isArEnable property in the component');
            this._init();
        } else if (this._commonService.canTriggerProductsCall()) {
            this.subscription.add(
                fromEvent(document, 'arFlagLoaded').subscribe(event => {
                    this.isArEnable = event && event['detail'] && event['detail']['arFlag'] ? event['detail']['arFlag']['display'] : false;
                    console.warn('== PRODUCT GENERIC GRID RECEIVED EVENT AND NOW IS READY TO MAKE PRODUCTS CALL');
                    this._init();
                })
            );
        } else {
            this._init();
        }
    }

    private _init() {
        // Get products in this.products to show in template
        if (this.qualifiedProducts != null) {
            if ((this.qualifiedProducts.ack == false || this.isOneTimeAddFlow) && this.qualifiedProducts.products && this.qualifiedProducts.products.length > 0) {
                const observeData = new Observable((obs: any) => {
                    obs.next(this.qualifiedProducts);
                    obs.complete();
                });

                this.calcTime('RECEIVED DATA');

                observeData.subscribe({next:(productsData: any) => {
                    switch (this.objGridData.drivenType) {

                        case 'purchase':

                            switch (this.objGridData.apiType) {

                                case 'buy-it-again':

                                    // README: Set active sort rule
                                    this.activeSortRule = this.objGridData.value.sortRule;
                                    break;

                                default:
                                    // Get default sort rule
                                    this.activeSortRule = this._sortService.getDefaultSort();
                                    break;
                            }
                            break;
                        default:
                            // Get default sort rule
                            this.activeSortRule = this._sortService.getDefaultSort();
                            break;
                    }

                    // send products data to add-all-button component
                    this._sendProductsToAddAllComponent(productsData);

                    // Get all departments from products
                    for (const product of productsData.products) {
                        this._productFilterService.addDepartment(product['departmentName']);
                    }

                    // Check if filter is enabled and filter products by aisle
                    if (this.isFilter === true) {
                        productsData.products = productsData.products.filter(
                            product => this._doFilter(product)
                        );
                    }

                    // Filter products with price 0 when allowNotAvailable is true
                    if (!this.allowNotAvailable) {
                        productsData.products = productsData.products.filter(p => (p.price > 0.00 && p.price != null));
                    }

                    // Pagination.
                    /* The below condition is to handle grid to load only initial set of products of the newly selected department
                       when a user switches from the previous department load-more products */
                    this.component.pagination.page = 1;
                    this._pagination(productsData);

                    this.checkAvailability(productsData.products);

                    // AR Project
                    this.arProductsArray = this.chunkArray([...productsData.products] || []);

                    this.calcTime('PROCESSED DATA');

                    // Count and show custom text for search page
                    this.searchResult(this.totalProducts);

                    // Subscribe to back to top button scroll event
                    this._dataScrollService.backToTopScroll$.subscribe(scrollY =>
                        this.showBackToTopButton = (scrollY > window.innerHeight)
                    );

                    if ((this.objGridData.apiType === 'c-bogo' || this.productGridPage === 'bogo') && $('.bogo--paragraph') != null) {
                        $('.bogo--paragraph').removeClass('mask');
                        $('.bogo--error').addClass('mask');
                    }

                    if (typeof productsData.brands !== 'undefined' && productsData.brands != null) {
                        for (const brand of productsData.brands) {
                            this._productFilterService.addBrand(brand);
                        }
                    } else if (this.productGridPage === 'search') {
                        const obsBrand = this._productGridService.extractBrand();
                        obsBrand.subscribe((brandsData: any) => {
                            if (typeof brandsData.brands !== 'undefined' && brandsData.brands != null) {
                                for (const brand of brandsData.brands) {
                                    this._productFilterService.addBrand(brand);
                                }
                            }
                        });
                    }
                }, error:(err) => {
                    this._processNoData();
                }});

            } else {
                this._processNoData();
            }

            // README: Reset server load-more flags
            this._isServerLoadMoreTriggered = false;

            setTimeout(() => { this.showGrid = true; $('#loadingConMedium').hide(); }, 10);


            this.calcTime('END');

        }
        else {
            this._processNoData();
        }
    }

    /**
     * Handle pagination with load more, infinite scroll or none.
     */
    private _pagination(productsArray: any): void {

        if (this.component.pagination.load_type === 'loadmore') {

            if (this.component.pagination.paginate_at === 'client') {
                const hasProducts = productsArray.products != null && productsArray.products !== '';

                //Do sorting for pages which are not driven by relelvancy
                if (this.productGridPage !== 'relevancy') {
                    // Load more pagination.
                    this.productsSecondary = hasProducts ? this.doSort(productsArray.products) : [];
                } else {
                    this.productsSecondary = hasProducts ? productsArray.products : [];
                }

                this.loadMoreProducts();

            } else if (
                this.component.pagination.paginate_at === 'server'
                && productsArray.products != null
                && productsArray.products !== ''
            ) {

                // README: Store new products
                this.products.push(...productsArray.products);

                // README: Validate load-more button
                this.hasServerSideLoadMore = this.products.length >= this._getLoadMoreItems() ? true : false;

                // README: Move focus to new items
                if (
                    this._serverNewItemToFocus
                    && this.products[this._serverNewItemToFocus]
                    && this.products[this._serverNewItemToFocus].id
                ) {
                    this.focusProduct(this._serverNewItemToFocus)
                }
            }

        } else if (this.component.pagination.load_type === 'infinitescroll' && this.component.pagination.infinite_type === 'client') {
            // We have infinite scroll Client pagination
            this.infiniteScroll(productsArray);

        } else if (this.component.pagination.load_type === 'infinitescroll' && this.component.pagination.infinite_type === 'server') {
            // We have infinite scroll Server pagination
            // TODO: Will be resolved with client pagination
            this.infiniteScroll(productsArray);

        } else {
            // We don't have any pagination, load all products
            this.products = (productsArray.products != null && productsArray.products !== '') ? productsArray.products : [];
            this.totalProducts = this.products.length;

            // Sort all products with default rule, except those on search and relevancy pages
            if (this.productGridPage !== 'search' && this.productGridPage !== 'relevancy' && this.isDynamicGridFlow !== true) {
                this.doSort();
            }
        }
    }

    public ngAfterViewInit(): void {
        this.calcTime('VIEW Init');
        if (window['AB'] && window['AB']['DATALAYER'] && this.calledBy === 'p13n') {
            window['AB']['DATALAYER'].trackP13nGrid(this.elementRef.nativeElement, this.qualifiedProducts);
        }
        if (this.isDynamicGridFlow === true) {
            this.handleProductsPerRowCalculations();
        }
    }

    private checkAvailability(products: any): void {
        this.areAllProductsUnavailable = this._productGridService.areAllProductsUnavailable(products);
    }

    private calcTime(msg: any) {
        const curTime: any = new Date();
        const pStrTime = this.pTime.getHours()
            + ':' + this.pTime.getMinutes()
            + ':' + this.pTime.getSeconds()
            + ':' + this.pTime.getMilliseconds();
        const curStrTime = curTime.getHours() + ':' + curTime.getMinutes() + ':' + curTime.getSeconds() + ':' + curTime.getMilliseconds();
    }

    public getCart() {
        let cartUrl = window['AB']['miniCartPath'];

        if (this._aemService.getOrderNumberCookie() !== '') {
            cartUrl += '?id=' + this._aemService.getOrderNumberCookie();
        }

        return this._http.get<any>(cartUrl);
    }

    private _doFilter(product: Object) {
        let result: boolean = true;

        result = window['AB']['COMMON'].getURLParameterByName('aisle')
            && (<string>product['departmentName'] === <string>this.filterAisleParam);

        return result;
    }

    public hasGroupHeading() {
        if (this.hasSort && this.isAisleSort && !this.isGroupInit) {
            this.isGroupInit = true;
            this.products.forEach((prod) => {
                if (prod[this.groupByField] !== this.currentGroupBy) {
                    this.currentGroupBy = prod[this.groupByField];
                    prod['isGroupSplit'] = true;
                }
            });
        }
    }

    /**
     * Sort products from view or sort optional array if passed in parameter
     *
     * @param {any} sortAnything is optional, may contains temp product array
     * @returns with sortAnything will returns the sorter array
     */
    public doSort(sortAnything?: any) {

        // README: reset this value in order to properly display group heading when sorting by Aisles
        this.currentGroupBy = '';

        this.products.forEach(product => {
            if (product.hasOwnProperty('isGroupSplit')) {
                delete product['isGroupSplit'];
            }
        });

        this.isGroupInit = false;

        if (sortAnything) {
            // Sort the optional parameter and returns sorted array
            // if program type is one time add flow, do not sort results
            return this.isOneTimeAddFlow ? sortAnything : this._sortService.sort(this.activeSortRule, sortAnything);

        } else if (this.component.pagination.load_type === 'loadmore') {

            if (!this.component.pagination.paginate_at || this.component.pagination.paginate_at === 'client') {

                // Sort for load more pagination
                // if program type is one time add flow, do not sort results
                this.productsSecondary = this.isOneTimeAddFlow
                    ? this.productsSecondary : this._sortService.sort(this.activeSortRule, this.productsSecondary);
                this.productsSecondary = this._sortProductsByDepartmentName(this.productsSecondary);
                this.products = this.productsSecondary.slice(0, this.component.pagination.load_items * this.component.pagination.page);

            } else if (this.component.pagination.paginate_at && this.component.pagination.paginate_at === 'server') {

                // README: Clear products array because the sort result starts from the beginning
                this.products = [];

                // REDME: Launch api call
                this._init();
            }

        } else if (this.component.pagination.load_type === 'infinitescroll' && this.component.pagination.infinite_type === 'client') {
            // Sort custom when infinite scroll on client side is activated
            // if program type is 1P _SNS do not sort results
            this.productsSecondary = this.isOneTimeAddFlow ?
                this.productsSecondary : this._sortService.sort(this.activeSortRule, this.productsSecondary);
            this.productsSecondary = this._sortProductsByDepartmentName(this.productsSecondary);
            this.products = this.productsSecondary.slice(0, this.infiniteScrollItems * this.infiniteScrollPage);

        } else {
            // Default: sort the products from viewport
            this.products = this._sortProductsByDepartmentName(this.products);
            // if program type is 1P _SNS do not sort results
            this.products = this.isOneTimeAddFlow 
                ? this.products : this._sortService.sort(this.activeSortRule, this.products);
        }

        this.isAisleSort = this.activeSortRule && this.activeSortRule.field === this._sortService.getSortByName('aisles').field;
        this.hasGroupHeading();
    }

    /**
     * Method sorting products by departmentName prop. This method groups the products by department and is used by the aisle sort rule.
     */
    private _sortProductsByDepartmentName(products: any) {
        let sortedProducts = products;
        // README: Sory by detpartmentName only if sort rule is 'Aisles'
        if (this.activeSortRule?.label === 'Aisles') {
            const compareDepartmentNames = (a: any, b: any) => {
                return a.departmentName < b.departmentName ? -1 : 1;
            };

            sortedProducts = products ? products.sort(compareDepartmentNames) : products;
        }
        return sortedProducts;
    }

    public activeSortRuleEmitter(activeSortRule: SortModel) {
        this.activeSortRule = activeSortRule;

        switch (this.objGridData.drivenType) {

            case 'purchase':

                switch (this.objGridData.apiType) {

                    case 'buy-it-again':

                        // README: Save selected sort rule for api call object
                        this.objGridData.value.sortRule = this.activeSortRule;

                        break;

                    default:
                        break;
                }
                break;

            default:
                break;
        }

        this.doSort();
    }

    public searchResult(searchNrResults: number) {
        const currentTitle: HTMLElement = <HTMLElement>document.querySelector('#searchNrResults');
        if (this.productGridPage === 'search' && currentTitle) {
            const searchQuery: string = window['AB']['COMMON'].getURLParameterByName('q');

            if (searchNrResults > 0) {
                currentTitle.innerHTML = searchNrResults + ' results for <b>' + searchQuery + '</b>';
            } else {
                if (searchQuery != null) {
                    currentTitle.innerText = 'No results for "' + searchQuery + '"';
                } else {
                    currentTitle.innerText = 'No results found.';
                }
                this.searchNoResults = true;

                document.querySelector('.asidediv.col-md-9').classList.remove('col-md-9');
                document.querySelector('.asidediv').classList.add('col-md-12');
            }
            window['AB']['DATALAYER'].updateSearch(searchQuery, searchNrResults);
        }
    }

    /**
     * Init infinite scroll pagination
     *
     * @param {any} data comming from api call, contains products
     */
    public infiniteScroll(data: any) {
        // Get all products in productsSecondary array and sort them with default rule
        this.productsSecondary = (data.products != null && data.products !== '') ? this.doSort(data.products) : [];
        this.infiniteScrollItems = this._dataScrollService.getNumberOfItems();
        this.totalProducts = this.productsSecondary.length;
        this.hideLoader();

        // Filter products with price 0 when allowNotAvailable is true
        if (!this.allowNotAvailable) {
            this.productsSecondary = this.productsSecondary.filter(p => (p.price > 0.00 && p.price != null));
        }

        // Filter case when are lower products than minimum required per infinite scrolling page
        if (this.productsSecondary.length <= this.infiniteScrollItems) {
            this.products = this.productsSecondary;
            this.doSort();
            return;
        }

        // Subscribe to scroll detection service to load more items
        this.$infiniteScroll = this._dataScrollService.pageToLoad$.pipe(
            takeWhile(() => this.products.length < this.productsSecondary.length)
        ).subscribe(pageNumber => {
                // Complete array with new products
                this.products = this._sortProductsByDepartmentName(this.products);
                this.products = this.productsSecondary.slice(0, this.infiniteScrollItems * pageNumber);
                this.infiniteScrollPage = pageNumber;
                this.showLoader();

                // Check required by aisle sort option
                this.isAisleSort = this.activeSortRule && this.activeSortRule.field === this._sortService.getSortByName('aisles').field;
                this.isGroupInit = false;
                this.hasGroupHeading();
                // Hide the spinner when all maximum pages were reached
                if (this.products.length === this.productsSecondary.length) {
                    this.hideLoader();
                }
            });
    }

    public checkRestrictedItems() {
        this.unAttendDeliveryFlag = true;
    }

  public loadSort() {
      if ((this.objGridData.doGenericFlow  && this.isDynamicGridFlow !== true) || (this.objGridData.apiType !== 'c-products-by-upc-drawer' && this.objGridData.apiType !== 's-bogo')) {
          return true;
      } else {
          return false;
      }
  }


    public removedProduct($productName) {
        this.afbEvent = 'Product ' + $productName + ' was removed';
    }



    /**
     * Scroll softly to the top and hide the button
     */
    public backToTopOnClick() {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        this.showBackToTopButton = false;
        const objTitleText = $('.title-bg h2.simple-page-title-text').get(0);
        if (objTitleText !== undefined) {
            objTitleText.focus();
        }
    }

    private _processNoData() {
        this.products = [];
        this.productsPerRowInPCRedesign = 0;
        this.displayNoResults = true;

        $('#loadingConMedium').hide();

        if (
            (this.objGridData.apiType === 'c-bogo' || this.productGridPage === 'bogo')
            && window['AB']['COMMON'].getBreakpoint() !== 'mobile'
        ) {

            this.noResults = this._productGridService.getNoResultsMsg(this.productGridPage);

            if ($('.bogo--error').length !== 0) {
                $('.bogo--error').html(this.noResults).removeClass('mask');
                $('.bogo--paragraph').addClass('mask');
            } else {
                $('.bogo--paragraph').after('<div class="bogo--error">' + this.noResults + '</div>');
            }
            this.noResults = '';
        }

        if (this.productGridPage === 'search') {
            this.searchResult(0);

            this._http.get(window['AB']['aisleHTMLTitlePath'], { 'responseType': 'text' })
                .subscribe(htmlTitlePath => {
                    this.aisleHTML = htmlTitlePath;

                    this._http.get(window['AB']['aisleHTMLPath'], { 'responseType': 'text' })
                        .subscribe(htmlPath => {
                            this.aisleHTML += htmlPath;
                        });
                });
        }

        // README: Hide server side load-more button
        if (
            this.component.pagination.load_type === 'loadmore'
            && this.component.pagination.paginate_at === 'server'
        ) {
            this.hasServerSideLoadMore = false;
        }

        if (this.hasServerSideLoadMore) {
            this.isServerGridLoading = false;
            this.hasServerSideLoadMore = false;
        }
    }

    public filterSnsNextOrderBpns(products) {
        //filter the products that have bpns equal to the ones equal in the snsNextOrderBpns localstorage object
        const lsSnsNextOrderBpns = localStorage.getItem('snsNextOrderBpns')
        if(lsSnsNextOrderBpns){
            const snsNextOrderBpns = JSON.parse(lsSnsNextOrderBpns);
            return products.filter(product => !snsNextOrderBpns.hasOwnProperty(product.id));
        }
        return products;
    }

    /**
     * Load next set of products when load more buttons is clicked.
     *
     * @param {string} call Call origin, act different if on init or button click.
     */
    public loadMoreProducts(call?: string) {
        let newItemToFocus: number;
        if (call === 'grid_button') {
            // Load more button is pressed, move focus to new products.
            newItemToFocus = this.products.length;
            this.component.pagination.page++;
        }
        if (call === 'grid_button' && this.isOneTimeAddFlow && this.searchKeyword?.length > 0) {
            //* Make API call for sns one time to get and set more products
            this._setMoreProducts(newItemToFocus);
        }else{
            this._showMoreProducts(newItemToFocus);
        }
        if (window['AB'] && window['AB']['DATALAYER'] && this.isOneTimeAddFlow && call === 'grid_button') {
            window['AB']['DATALAYER'].setLinkClickEvents(`ota-${this.searchKeyword?.length > 0 ? 'search-results' : 'bia'}:load-more|page:${this.component.pagination.page - 1}`);
        }
    }

    /**
     * Make Search API call to load more products onto grid
     */
    private _setMoreProducts(newItemToFocus: number) {
        this.isServerGridLoading = true;
        this._productGridService.getMoreSearchProducts({
                searchQuery: this.searchKeyword,
                start: (this.component.pagination.page - 1) * this.component.pagination.load_items,
                rows: this.component.pagination.load_items,
                fulfillmentType: this.snsFulfillmentType,
                nextPageToken: this.nextPageToken
            })
            .subscribe((productsData: any) => {
                if(productsData.products &&  productsData?.products?.length>0){
                    this.productsSecondary = this.productsSecondary.concat(this.filterSnsNextOrderBpns(productsData.products));
                }
                if(productsData.offers){
                    this.dataOffers['offers'] = {...this.dataOffers?.['offers'], ...productsData.offers};
                }
                this.isServerGridLoading = false;
                this.nextPageToken = productsData?.nextPageToken ?? '';
                this._showMoreProducts(newItemToFocus);
            },(error)=>{
                this.component.pagination.page--;
                this.isServerGridLoading = false;
                this._commonService.dispatchCustomOneTimeEvent('snsOneTime','loadMoreUpdateError',{});
            });
    }

    private _showMoreProducts(newItemToFocus: number) {

        this.productsSecondary = this._sortProductsByDepartmentName(this.productsSecondary);
        this.products = this.productsSecondary.slice(0, this.component.pagination.load_items * this.component.pagination.page);

        // AR Project
        const products = [...this.products];
        this.arProductsArray = this.chunkArray(products || [])

        // Check required by aisle sort option.
        //this.isAisleSort = this.activeSortRule && this.activeSortRule.field === this._sortALV1Service.getSortByName('aisles').field;
        this.isGroupInit = false;
        this.hasGroupHeading();

        // Move focus to new items.
        if (newItemToFocus && this.products[newItemToFocus].id) {
            this.focusProduct(newItemToFocus);
        }
    }

    public focusProduct(newItemToFocus: number) {
        if (newItemToFocus == null) return;

        // Focus on the newest product shown after it appears then remove the observer
        const observer = new MutationObserver(function (mutations) {
            setTimeout(() => {
                const itemPrefix =  'product-item-al-v2';
                const productFocusElem = document.querySelectorAll(itemPrefix)[newItemToFocus];
                if (productFocusElem) {
                    const titleName = productFocusElem.querySelector('.product-fname');
                    (<HTMLElement>titleName).focus();
                    this.disconnect();
                }
            }, 500);
        });

        const target = this.elementRef.nativeElement;
        observer.observe(target, {
            childList: true,
            subtree: true
        });
    }

    /**
     * Load next set of products from a server call HTTP request.
     *
     * @param {string} call Call origin, act different if on init or button click.
     */
    public loadMoreProductsServerSide(call?: string) {

        this._isServerLoadMoreTriggered = true;
        this.isServerGridLoading = true;

        if (call === 'grid_button') {
            // Load more button is pressed, move focus to new products.
            this._serverNewItemToFocus = this.products.length;
        }

        switch (this.objGridData.drivenType) {

            case 'purchase':

                switch (this.objGridData.apiType) {

                    case 'buy-it-again':

                        // README: Increment pageNumber value before API call
                        this.objGridData.value.pageNumber = this.objGridData.value.pageNumber + 1;

                        // README: Proceed with the API call for data.
                        this._init();

                        break;

                    default:

                        // Sanity check
                        // FIXME: If flow is introduced here, then move the flag reset after request response parsing is complete.
                        this._isServerLoadMoreTriggered = false;

                        break;
                }

                break;

            default:

                // Sanity check
                // FIXME: If flow is introduced here, then move the flag reset after request response parsing is complete.
                this._isServerLoadMoreTriggered = false;

                break;
        }
    }

    /**
     * Grab the items suited for the device width, breakpoints are from bootstrap media queries.
     *
     * @default mobile  15 items per page.
     * @default tablet  20 items per page.
     * @default desktop 30 items per page.
     */
    private _getLoadMoreItems() {

        if (window.innerWidth <= 768) {
            return this._componentElement.getAttribute('data-load-more-mobile-items')
                ? this._componentElement.getAttribute('data-load-more-mobile-items')
                : 15;

        } else if (window.innerWidth > 768 && window.innerWidth <= 992) {
            return this._componentElement.getAttribute('data-load-more-tablet-items')
                ? this._componentElement.getAttribute('data-load-more-tablet-items')
                : 20;
        }

        // width above 992px
        return this._componentElement.getAttribute('data-load-more-desktop-items')
            ? this._componentElement.getAttribute('data-load-more-desktop-items')
            : 30;
    }

    /**
     * Checks the respective product is available or not
     */
    public isItemAvailable(product) {
        return this._commonService.isItemAvailable_v2(product);
    }

    /**
     * Checks any product in grid row is arEnabled or not
     */
    private checkAnyProductHasAddlInfo = (products) => !!products ? products.some(product => (product?.isArProduct && this.isArEnable) || product?.isMarketplaceItem == 'Y') : false;

    /**
     * Based on device type, divide product array into different chunks
     * Other than mobile view we display 4 product cards per row
     */
    public chunkArray(products) {
        const chunkSize: number = window.location.href.includes("foru/offer-details") ? 6 : 4;
        const size = window.innerWidth < 768 ? 2 : chunkSize;
        const subArray = [];

        while (products.length) {
            subArray.push(products.splice(0, size));
        }

        return subArray;
    }

    public checkAnyArProductInRow(product) {
        // Using product UPC, first it will check for corresponding product and then corresponding subArray (i.e. row)
        if(this.isOneTimeAddFlow){
            return false;
        }
        const subArray = this.arProductsArray ? this.arProductsArray.find(item => item.find(item1 => item1.pid === product.pid)) : [];
        return subArray ? this.checkAnyProductHasAddlInfo(subArray) : false;
    }

    private handleProductsPerRowCalculations() {
        setTimeout(() => {
            // Fix for bug with not rendering CaaS comps after clicking on coupon then load more.
            // Issue was caused by right drawer opening and adding a new grid to page, which has a .pc-grid. 
            // Ensure we are keying off the correct element by using elementRef.nativeElement. 
            const containerElement = (this.elementRef.nativeElement.querySelector('.pc-grid') as HTMLElement);
            const productElement = (this.elementRef.nativeElement.querySelector('.pc-grid-prdItem') as HTMLElement); 
            this.productsPerRowInPCRedesign = this.products.length > 0 ? this._productGridService.calculateCardsPerRow(containerElement, productElement) : 0;
            this.fullWidthIndices = this._productGridService.calculateFullWidthIndices(this.products, this.productsPerRowInPCRedesign);
        }, 0);
    }

    private _sendProductsToAddAllComponent(productsData) {
        let products = productsData.products;
        if (this.objGridData.apiType === 'c-virtual-shelf-general') {
            if (products.length > 50 || products.length === 0 || $('.load-more').length > 0) {
                $('.dynamic-angular-content-injector').hide();
            } else {
                $('.dynamic-angular-content-injector').show();

                //README: send only in stock products(inventoryAvailable === "1")
                products = products.filter(item => item.inventoryAvailable === "1");
                this._commonService._products.next(products);
            }
        }
    }
    private showLoader(): void {
        this._loaderService.show();
    }

    private hideLoader(): void {
        this._loaderService.hide();
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}
